import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "tracks-data grid" }
const _hoisted_4 = { class: "col md:col-12 track-select-div" }
const _hoisted_5 = { class: "col md:col-12" }
const _hoisted_6 = { class: "add-track list-manage-link" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "tracks-data grid" }
const _hoisted_9 = { class: "col md:col-12 track-select-div" }
const _hoisted_10 = { class: "form-input" }
const _hoisted_11 = { class: "buttons-container" }
const _hoisted_12 = {
  key: 0,
  class: "flex-buttons"
}
const _hoisted_13 = {
  key: 1,
  class: "flex-buttons"
}
const _hoisted_14 = {
  key: 2,
  class: "flex-buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_EditBox = _resolveComponent("EditBox")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Wysiwyg = _resolveComponent("Wysiwyg")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.showManage,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showManage) = $event)),
    title: _ctx.getModalTitle,
    showFooter: true,
    onCancel: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _createVNode(_component_TranslatedText, { path: _ctx.getModalDescription }, null, 8, ["path"])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1))
      ]),
      (!_ctx.trackCreateManage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_EditBox, {
                  tabindex: "0",
                  value: _ctx.selectedTrack,
                  items: _ctx.getTrackOptions,
                  label: "track.manage.current-tracks",
                  onEdit: _ctx.handleEditTrack,
                  onChange: _ctx.handleTrackManageChange,
                  onMoveUp: _ctx.handleTrackMoveUp,
                  onMoveDown: _ctx.handleTrackMoveDown
                }, null, 8, ["value", "items", "onEdit", "onChange", "onMoveUp", "onMoveDown"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  (_ctx.userHasPermission('track:manage:groups'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleTrackCreate && _ctx.handleTrackCreate(...args)), ["prevent"]))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "plus" }),
                        _cache[5] || (_cache[5] = _createTextVNode("  ", -1)),
                        _createVNode(_component_TranslatedText, { path: "track.manage.add.track" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.trackCreateManage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_FormInput, {
                    id: "name",
                    name: "name",
                    label: 'Track Name',
                    placeholder: 'Enter track name',
                    value: _ctx.model.name,
                    required: true,
                    onInput: _ctx.handleInputChange
                  }, null, 8, ["value", "onInput"])
                ]),
                _createVNode(_component_Wysiwyg, {
                  name: "description",
                  label: "Track description",
                  value: _ctx.model.description,
                  required: true,
                  onInputChange: _ctx.handleQuillInputChange,
                  ref: "quill"
                }, null, 8, ["value", "onInputChange"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        (!_ctx.trackCreateManage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_Button, {
                text: "common.close",
                size: "sm",
                variant: "secondary",
                onClick: _ctx.closeModal
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.trackCreateManage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_Button, {
                text: "common.cancel",
                size: "sm",
                variant: "secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackCreateManage = false))
              }),
              (_ctx.trackCreateManage)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    text: 
              _ctx.model?.id ? 'track.manage.edit.save' : 'track.manage.create.save'
            ,
                    size: "sm",
                    onClick: _ctx.handleDoSaveManage
                  }, {
                    labelAfter: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
                    ]),
                    _: 1
                  }, 8, ["text", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.trackCreateManage && _ctx.model?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_Button, {
                text: "track.manage.delete-track",
                size: "sm",
                variant: "error",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDoDeleteTrack(_ctx.model.id))),
                class: "w-100"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onCancel"]))
}